// HARDCODED

// Questionnaire Id - Question Id
export const QuantityMapping: Record<string, { quantityQuestionId: string, defaultQuantity: string }> = {
    //LDN Initial - Are you currently taking LDN?
    "03c26815-061d-41b4-8264-c5d1a0d78614":
        { quantityQuestionId: "f3a27432-59e2-4698-9d95-73afe86fd9f0", defaultQuantity: "30" },
    //Propanalol Initial - Have you ever taken propranolol before?
    "c5820fc8-607f-49f9-a675-2c67f7f89671":
    {
        quantityQuestionId: "2810cf0d-41a8-4d69-bfb0-09e2d2e32508", defaultQuantity: "30"
    },
    //Pyridostigmine Initial - Are you currently taking propranolol?
    "4f64646f-40ec-47e3-8e95-9a77aa04feaa":
    {
        quantityQuestionId: "18dbace0-f288-4f34-b951-5a5fa4728790", defaultQuantity: "30"
    },
    //Ketotifen Initial - Are you currently taking ketotifen?
    "5f0ee7a3-95bb-45e9-b41f-15bf6976aa98":
    {
        quantityQuestionId: "d2028759-83d0-48e0-821e-c7cf37f58aff", defaultQuantity: "30"
    },
    //Midodrine Initial - Have you ever taken midodrine before?
    "5f453fbc-f2a4-4129-8440-9fe282e78299":
    {
        quantityQuestionId: "6dd28ae8-3bff-455c-9bc4-7bb787af21e7", defaultQuantity: "30"
    },
    //Metformin (chronic) Initial - Are you currently taking metformin?
    "02bb4689-4dcc-4912-b618-4cbfc73299ea":
    {
        quantityQuestionId: "c4582e8f-c55b-49bc-bb87-f85d43aa737a", defaultQuantity: "30"
    },
    //Metformin (acute) Initial - Are you currently taking metformin?
    "cd9ee8bd-0205-428f-9ce9-7f2f904c5283":
    {
        quantityQuestionId: "c4582e8f-c55b-49bc-bb87-f85d43aa737a", defaultQuantity: "14"
    },
    //Ocaloacetate Initial - Are you currently taking oxaloacetate?
    "835cc331-29f4-4536-ba5f-33bfcce11d7b":
    {
        quantityQuestionId: "d7c2b543-7969-4d08-8629-0ed1776ad91c", defaultQuantity: "30"
    },
    //Ivabradine Initial - Are you currently taking oxaloacetate?
    "71845993-2b42-4e39-a37c-3f66cda8d0ca":
    {
        quantityQuestionId: "2f47991b-b3fd-4b3a-84d8-01dd513cb0ad", defaultQuantity: "30"
    },
};

export const DiagnosisMapping: Record<string, string> = {
    //LDN Initial - No question
    "03c26815-061d-41b4-8264-c5d1a0d78614":
        "",
    //Propanalol Initial - Have you been diagnosed with any of the following conditions by a licensed clinician?
    "c5820fc8-607f-49f9-a675-2c67f7f89671":
        "0d86b895-2ac0-497b-959c-582ea5b8698b",
    //Pyridostigmine Initial - Have you been diagnosed with any of the following conditions by a licensed clinician?
    "4f64646f-40ec-47e3-8e95-9a77aa04feaa":
        "43d1c247-72c5-441a-b1e0-e979405e1d56",
    //Ketotifen Initial - Have you been diagnosed with any of the following conditions by a licensed clinician?
    "5f0ee7a3-95bb-45e9-b41f-15bf6976aa98":
        "feffc58d-2483-4d4a-820e-9fc1626ee102",
    //Midodrine Initial - Have you been diagnosed with any of the following conditions by a licensed clinician?
    "5f453fbc-f2a4-4129-8440-9fe282e78299":
        "3118525e-2c7e-4443-8ecf-98b141c5e00a",
    //Metformin (chronic) Initial - Have you been diagnosed with any of the following conditions by a licensed clinician?
    "02bb4689-4dcc-4912-b618-4cbfc73299ea":
        "a4d5fd97-1476-43d5-9a1c-9bb19e868f08",
    //Metformin (acute) Initial - Have you been diagnosed with any of the following conditions by a licensed clinician?
    "cd9ee8bd-0205-428f-9ce9-7f2f904c5283":
        "40980789-be9e-48ee-925e-13325d0a09c5",
    //Ocaloacetate Initial - Have you been diagnosed with any of the following conditions by a licensed clinician?
    "835cc331-29f4-4536-ba5f-33bfcce11d7b":
        "aaf22986-d81a-41e5-b125-44a5d54e3331",
    //Ivabradine Initial - Have you been diagnosed with any of the following conditions by a licensed clinician?
    "71845993-2b42-4e39-a37c-3f66cda8d0ca":
        "30b1058f-3aec-4435-a27f-7731a66a914c"
};

export const STRIPE_QUESTION_ID = "73dc1938-b5a9-428a-b864-d3d478b8d549";
export const PERSONA_QUESTION_ID = "fe484947-2fad-4475-9ef3-c65d1b5139b5";
export const CONFIRM_QUESTION_ID = "f8d67cb6-ebe1-45db-b2a0-afb18b1dae67";

export const LDN_TREATMENT_ID = '66743ab5-322f-4e3b-8818-c8cd8b374ef9'
export const METFORMIN_TREATMENT_ID = '7b85bce5-0348-467e-a662-941f5be59b2b'
export const OXALOACETATE_TREATMENT_ID = "10a0c859-3423-468f-b156-7b2e457d9ac8";
export const KETOTIFEN_TREATMENT_ID = '9ecf3d7b-a746-4f33-9a04-5e5563205ccb'
export const IVABRADINE_TREATMENT_ID = "3c292b0b-7a04-4dca-9956-9d238de942a5";
export const PROPRANOLOL_TREATMENT_ID = "fa70f123-912d-41cf-994a-2d0ef4048ebf";
export const PYRIDOSTIGMINE_TREATMENT_ID = "358b2d73-2e85-407e-8a70-4e439013bde2";
export const MIDODRINE_TREATMENT_ID = "01df2a69-2769-47b1-bc9a-2d516b1295fb";

export const PROPRANOLOL_INITIAL_QUESTIONNAIRE_ID = "c5820fc8-607f-49f9-a675-2c67f7f89671";
export const PYRIDOSTIGMINE_INITIAL_QUESTIONNAIRE_ID = "4f64646f-40ec-47e3-8e95-9a77aa04feaa";
export const OXALOACETATE_DIAGNOSES_QUESTION_ID = "aaf22986-d81a-41e5-b125-44a5d54e3331";


export const THIRTY_DAYS_IN_MS = 30 * 24 * 60 * 60 * 1000; // 30 days in milliseconds

export const TreatmentNameToInitialQuestionnaireIDMapping: Record<string, string> = {
    "Midodrine": "5f453fbc-f2a4-4129-8440-9fe282e78299",
    "Metformin": "cd9ee8bd-0205-428f-9ce9-7f2f904c5283",
    "Oxaloacetate": "835cc331-29f4-4536-ba5f-33bfcce11d7b",
    "Propranolol": "c5820fc8-607f-49f9-a675-2c67f7f89671",
    "Pyridostigmine": "4f64646f-40ec-47e3-8e95-9a77aa04feaa",
    "Ketotifen": "5f0ee7a3-95bb-45e9-b41f-15bf6976aa98",
    "LDN": "03c26815-061d-41b4-8264-c5d1a0d78614",
    "Low Dose Naltrexone": "03c26815-061d-41b4-8264-c5d1a0d78614",
    "Ivabradine": "71845993-2b42-4e39-a37c-3f66cda8d0ca"
}

export const TreatmentNameToMarketingPageURLMapping: Record<string, string> = {
    "Guanfacine": "https://www.direct.rthm.com/guanfacine",
}
